import { Box, Typography } from '@mui/material';
import React from 'react';
import { Alert } from 'framework/ui/mui-builder';
import { ShowSection } from 'framework/ui/layout';
import { FormShowTemplate } from 'framework/form';
import { EditableListDataGridLayout, EditableListFormShowTemplate } from 'framework/list';

type GetTableCells = React.ComponentProps<typeof EditableListDataGridLayout>['getTableCells'];
type ControlListSectionProps<T> = {
  title: string;
  items: T[];
  listSource: string;
  emptyMessage: string;
  getTableCells: GetTableCells;
};

const DEFAULT_ROW_PROPS = () => ({
  sx: {
    alignItems: 'center',
    pl: 0,
    p: 1,
  },
});

const ControlListSection = <T,>({
  title,
  items,
  listSource,
  emptyMessage,
  getTableCells,
}: ControlListSectionProps<T>) => {
  if (items.length === 0) {
    return (
      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle1" color="primary" mb={1}>
          {title}
        </Typography>
        <Alert severity="info" icon={' '}>
          {emptyMessage}
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle1" color="primary" mb={1}>
        {title}
      </Typography>
      <ShowSection sx={{ p: '0px!important' }}>
        <FormShowTemplate
          initialData={{ [listSource]: items }}
          submitFormFunc={() => Promise.resolve({ [listSource]: items })}
        >
          <EditableListFormShowTemplate listSource={listSource}>
            <EditableListDataGridLayout rowProps={DEFAULT_ROW_PROPS} getTableCells={getTableCells} />
          </EditableListFormShowTemplate>
        </FormShowTemplate>
      </ShowSection>
    </Box>
  );
};

export default ControlListSection;
